import React, { useState, useEffect } from "react";
import { MoveLeft, ChevronDown, EllipsisVertical } from "lucide-react";
import Dropdown from "react-bootstrap/Dropdown";
import { Button, Toast, ToastContainer } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import vendor from "../../assets/svg/vendor/vendor.svg";
import "../Vehicles/Vehicle_list/List.css";
import locationIc from "../../assets/svg/vendor/location.svg";
import mobile from "../../assets/svg/vendor/mobile.svg";
import mail from "../../assets/svg/vendor/mail.svg";
import calender from "../../assets/svg/vendor/calender.svg";
import { getVendorDetailsApi, vendorStatusUpdateApi } from "./vendor-api.js";
import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";
import { useGlobal } from "../../GlobalContext.js";
import profileIc from "../../assets/png/profile-ic.png";
export const ViewVendor = () => {
  const { rolePermissionList, userType } = useGlobal();
  const googleMapsApiKey = process.env.REACT_APP_GOOGLE_MAP_KEY;

  const [center, setCenter] = useState({
    lat: 13.0843,
    lng: 80.2705,
  });

  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(false);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);
  const handleStatusChange = (status) => {
    // 1️⃣ Update local state
    setStatusValue(status);

    // 2️⃣ Call another function, e.g., API update
    vendorStatusUpdate(status);
  };

  const [statusValue, setStatusValue] = useState("Active");
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: googleMapsApiKey,
  });
  const [marker, setMarker] = useState(null);

  const navigate = useNavigate();

  const location = useLocation();
  const { id } = location.state || {};

  useEffect(() => {
    if (id != null && id !== undefined && id !== 0) {
      getVendorDetails(id);
    }
  }, [id]);
  // useEffect(() => {
  //   if (statusValue) {
  //     vendorStatusUpdate(statusValue); // pass the current value
  //   }
  // }, [statusValue]); // runs whenever statusValue changes

  const [vendorDetail, setVendorDetail] = useState({});

  const vendorStatusUpdate = async (value) => {
    const bodyData = {
      status: value === "Active" ? true : false,
    };
    try {
      const response = await vendorStatusUpdateApi(id, bodyData);

      if (response.data.success === true) {
        getVendorDetails(id);
        setSnackbarMessage(response.data.message);
        setSnackbarStatus(response.data.success);
        handleSnackbarShow();
      } else {
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const getVendorDetails = async (id) => {
    try {
      const response = await getVendorDetailsApi(id);

      if (response.data.success === true) {
        const vendorDetails = response.data.vendor ?? {};
        setVendorDetail(response.data.vendor ?? {});
        setStatusValue(response.data.vendor.status === true ? "Active" : "InActive");
        if (vendorDetails.latitude != null && vendorDetails.latitude !== "") {
          setMarker({
            lat: Number(vendorDetails.latitude),
            lng: Number(vendorDetails.longitude),
          });
          setCenter({
            lat: Number(vendorDetails.latitude),
            lng: Number(vendorDetails.longitude),
          });
        }
      } else {
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const details = [
    {
      label: "Mobile number",
      value: (
        <div className="d-flex align-items-center gap-2">
          <img src={mobile} alt="location" />
          <span>{vendorDetail.phone_no ?? ""}</span>
        </div>
      ),
    },
    {
      label: "Mail ID",
      value: (
        <div className="d-flex align-items-center gap-2">
          <img src={mail} alt="location" />
          <span>{vendorDetail.email ?? ""}</span>
        </div>
      ),
    },
    {
      label: "Due date",
      value: (
        <div className="d-flex align-items-center gap-2">
          <img src={calender} alt="location" />
          <span>{vendorDetail.due_date ?? ""}</span>
        </div>
      ),
    },

    {
      label: "Address",
      value: (
        <div className="d-flex align-items-center gap-2">
          <img src={locationIc} alt="location" />
          <span>{vendorDetail.address ?? ""}</span>
        </div>
      ),
    },
  ];

  function checkPermission(menuName, permission) {
    return rolePermissionList.findIndex((element) => element["name"] === menuName && element["menu_permission"] === true && element[permission] === true) > -1 ? true : false;
  }

  return (
    <div>
      <div className="w-100 bg-half-white">
        <div className="d-flex flex-wrap justify-content-between align-items-center bg-white p-3">
          <div className="d-flex align-items-center gap-3">
            <div
              className="border p-2 rounded-circle cursor-pointer"
              onClick={() => {
                navigate(-1);
              }}
            >
              <MoveLeft />
            </div>
            <div
              className="bg-white"
              style={{
                width: "70px",
                height: "70px",
                borderRadius: "70px", // container border radius
                overflow: "hidden", // ensures image is clipped to border radius
              }}
            >
              <img
                src={vendorDetail.image ?? profileIc}
                alt="vendor"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />
            </div>

            <div>
              <p className="m-0 fs-20 fw-semibold mb-1">{vendorDetail.name ?? ""}</p>
              <div className="d-flex align-items-center">
                <span className="me-2 fs-13 fw-600" style={{ color: "#8790A1" }}>
                  {vendorDetail.type ?? ""}
                </span>
                <span className="me-2">•</span>
                <span className="border-0 bg-list-purple text-dark-purple py-1 px-4 rounded-pill fs-14 fw-400">{vendorDetail.vendor_id ?? ""}</span>
              </div>
            </div>
          </div>
          <div className="d-flex align-items-center gap-3">
            <Dropdown>
              <Dropdown.Toggle variant="success" id="dropdown-basic" className="bg-white border rounded-pill d-flex justify-content-between align-items-center gap-2 dpm-toggle">
                <div className={statusValue === "Active" ? "green-dot" : "red-dot"}></div>
                <span>{statusValue}</span>
                <span className="pagination-color">
                  <ChevronDown />
                </span>
              </Dropdown.Toggle>

              <Dropdown.Menu style={{ minWidth: "unset", width: "100%" }}>
                <Dropdown.Item onClick={() => handleStatusChange("Active")}>Active</Dropdown.Item>
                <Dropdown.Item onClick={() => handleStatusChange("Inactive")}>Inactive</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>

            {checkPermission("Vendor", "create_permission") && (
              <Button
                onClick={() => {
                  navigate("/vendor/create", { state: { id: id } });
                }}
                className="dark-purple-btn rounded-pill py-2 px-4"
              >
                Edit
              </Button>
            )}
            {/*  <div className="border rounded-circle p-2 cursor-pointer">
              <EllipsisVertical />
            </div> */}
          </div>
        </div>
        <div className="row m-0 px-2">
          <div className="col-xl-6">
            <div className="bg-white rounded-4 p-3 mt-3 h-100">
              <p className="m-0 fs-15 fw-600">Vendor details</p>
              <div className="table-container rounded-4 overflow-hidden my-3">
                <table className="table table-borderless mb-0">
                  <tbody>
                    {details.map((item, index) => (
                      <tr key={index}>
                        <td className="fs-13 fw-500 w-50" style={{ color: "#49494B" }}>
                          {item.label}
                        </td>
                        <td className="fs-13 fw-400" style={{ color: "#172B4D" }}>
                          {item.value}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div className="col-xl-6">
            <div className="bg-white rounded-4 p-3 mt-3 h-100">
              <p>Description</p>
              <p>{vendorDetail.description ?? ""}</p>
            </div>
          </div>
        </div>
        <div className="bg-white rounded-4 p-3 mx-3 mt-5">
          <p>Location</p>
          {isLoaded && (
            <GoogleMap mapContainerStyle={{ width: "100%", height: 400 }} center={center} zoom={14}>
              {marker && <Marker position={marker} />}
            </GoogleMap>
          )}
        </div>
      </div>
      <ToastContainer position="top-end">
        <Toast className="d-inline-block m-1" bg={snackbarStatus === true ? "success" : "danger"} show={showSnackbar} onClose={handleSnackbarClose} delay={3000} autohide>
          <Toast.Body style={{ color: "#ffffff" }}>{snackbarMessage}</Toast.Body>
        </Toast>
      </ToastContainer>
    </div>
  );
};
